<!-- eslint-disable vue/valid-v-if -->
<template>
    <div v-if="selfServiceDetails.tag ==='end'">
        <b-alert variant="success" v-if="!faethmId && !bobClientId && !isAccountLinking" show>
            <p>{{$t('pages.selfservice.passwordReset.successMessage')}}</p>
        </b-alert>
        <p v-else-if="isAccountLinking" class="account-linking-success">
            {{$t('pages.selfservice.passwordReset.accountLinkingSuccessMsg')}}
        </p>
        <span variant="success" v-else-if="faethmId || bobClientId">
            <h1 class="faethm-success-title">{{$t('pages.selfservice.passwordReset.successMsg')}}</h1>
            <p>{{$t('pages.selfservice.passwordReset.successMessage')}}</p>
        </span>
        <div v-if="selfServiceDetails.additions">
            <a :href="forceReauthAndRedirect(selfServiceDetails.additions.successUrl)">{{ $t('pages.selfservice.passwordReset.returnToSignInAnchorText')}}</a>
        </div>
    </div>
    <div v-else-if="typeof selfServiceDetails.error !== 'string'">
        <b-alert v-if="typeof selfServiceDetails.validationError === 'string'" variant="danger" show>
            <p>{{selfServiceDetails.validationError}}</p>
        </b-alert>
         <ValidationObserver ref="observer" v-if="faethmId || bobClientId" slim>
            <b-form @keyup.enter="save" @submit.prevent>
                <h1 class="faethm-create-pwd">{{$t('pages.selfservice.passwordReset.createNewPassword')}}</h1>
                <p class='subtitle1' v-if="!isAccountLinking">
                    {{$t(`pages.selfservice.passwordReset.subTitle`)}}
                </p>
                <ValidationProvider :rules="calculateValidation()" v-slot="{ errors }" :name="translatedPasswordField">
                    <label v-if="faethmId || bobClientId" class="faethm-label-align" :for="`password-${_uid}`">{{ $t('pages.selfservice.registration.userDetails.password') }}</label>
                    <div class="mb-3">
                        <div class="form-label-password form-label-group mb-0" ref="floatingLabelGroup">
                            <input :type="inputType"
                                :id="`password-${_uid}`"
                                :class="{'form-control custom-text ': true, 'error': errors.length > 0}"
                                ref="password"
                                :placeholder="!(faethmId || bobClientId) ? $t('pages.selfservice.registration.userDetails.password') : ''"
                                :reveal="true" data-vv-validate-on="input|keyup|submit" v-model="password"
                                @keydown.space="(event) => event.preventDefault()"
                                :data-vv-as="$t('pages.selfservice.registration.userDetails.password')">
                            <div class="password-toggle-icon" @click="revealText" tabindex="-1">
                                <i :class="[{'fa-eye': !show}, {'fa-eye-slash': show}, 'fa']"></i>
                            </div>
                        </div>
                        <div class="fr-validation-requirements text-left faethm-password-input">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <ValidationProvider :rules="confirmValidationRules()" v-slot="{ errors }"
                    :name="translatedConfirmPasswordField">
                    <label v-if="faethmId || bobClientId" class="faethm-label-align" :for="`confirm-password-${_uid}`">{{ $t('pages.selfservice.registration.userDetails.confirmpassword') }}</label>
                    <div class="mb-3">
                        <div class="form-label-password form-label-group mb-0" ref="floatingLabelGroup">
                            <input data-vv-validate-on="input|keyup|submit" :type="inputConfType"
                                :id="`confirm-password-${_uid}`"
                                :class="{'form-control custom-text ': true, 'error': errors.length > 0}"
                                :placeholder="!(faethmId || bobClientId) ? $t('pages.selfservice.registration.userDetails.confirmpassword') : ''"
                                :data-vv-as="$t('pages.selfservice.registration.userDetails.confirmpassword')"
                                v-model="userPassword" @keydown.space="(event) => event.preventDefault()">
                            <div class="password-toggle-icon" @click="revealconfirmText" tabindex="-1">
                                    <i :class="[{'fa-eye': !showconf}, {'fa-eye-slash': showconf}, 'fa']"></i>
                            </div>
                        </div>
                        <div class="fr-validation-requirements text-left faethm-password-input">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <div style="text-align:right;">
                    <!--<fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp"
                                :label="$t('common.form.cancel')"
                                :large="true"
                                @click="$router.go(-1)"></fr-loading-button>-->
                    <fr-loading-button type="button" variant="primary" :class="[{ 'w-100 d-inline-block buttondisp': (faethmId || bobClientId) },'w-50 d-inline-block buttondisp']"
                        style="display:inline-block!important;" :label="$t('common.form.submit')" :loading="loading"
                        :large="true" @click="save"></fr-loading-button>
                </div>
            </b-form>
        </ValidationObserver>
        <ValidationObserver ref="observer" v-if="!faethmId && !bobClientId"  slim>
            <b-form @keyup.enter="save" @submit.prevent>
                <p class='subtitle1' v-if="!isAccountLinking">
                    {{$t(`pages.selfservice.passwordReset.subTitle`)}}
                </p>
                <label>{{$t('pages.selfservice.registration.userDetails.password')}}</label>
                <ValidationProvider :rules="calculateValidation()" v-slot="{ errors }" :name="translatedPasswordField">
                    <div class="mb-3">
                        <div class="form-label-password form-label-group mb-0" ref="floatingLabelGroup">
                            <input :type="inputType"
                                :class="{'form-control custom-text ': true, 'error': errors.length > 0}"
                                ref="password"
                                :reveal="true" data-vv-validate-on="input|keyup|submit" v-model="password"
                                @keydown.space="(event) => event.preventDefault()"
                                :data-vv-as="$t('pages.selfservice.registration.userDetails.password')">
                            <div class="input-group-append">
                                <button @click="revealText"
                                    :class="{'form-control custom-text ': true, 'error': errors.length > 0}"
                                    type="button" tabindex="-1">
                                    <i :class="[{'fa-eye': !show}, {'fa-eye-slash': show}, 'fa']"></i>
                                </button>
                            </div>
                        </div>
                        <div class="fr-validation-requirements text-left">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <label>{{$t('pages.selfservice.registration.userDetails.confirmpassword')}}</label>
                <ValidationProvider :rules="confirmValidationRules()" v-slot="{ errors }"
                    :name="translatedConfirmPasswordField">
                    <div class="mb-3">
                        <div class="form-label-password form-label-group mb-0" ref="floatingLabelGroup">
                            <input data-vv-validate-on="input|keyup|submit" :type="inputConfType"
                                :class="{'form-control custom-text ': true, 'error': errors.length > 0}"
                                :data-vv-as="$t('pages.selfservice.registration.userDetails.confirmpassword')"
                                v-model="userPassword" @keydown.space="(event) => event.preventDefault()">
                            <div class="input-group-append">
                                <button @click="revealconfirmText"
                                    :class="{'form-control custom-text ': true, 'error': errors.length > 0}"
                                    type="button" tabindex="-1">
                                    <i :class="[{'fa-eye': !showconf}, {'fa-eye-slash': showconf}, 'fa']"></i>
                                </button>
                            </div>
                        </div>
                        <div class="fr-validation-requirements text-left">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <div>
                    <!--<fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp"
                                :label="$t('common.form.cancel')"
                                :large="true"
                                @click="$router.go(-1)"></fr-loading-button>-->
                    <fr-loading-button type="button" variant="primary" :class="[ { 'w-100 d-inline-block buttondisp': (faethmId || bobClientId || gedManagerId) },'d-inline-block buttondisp']"
                        style="display:inline-block!important;" :label="$t('common.form.submit')" :loading="loading"
                        :large="true" @click="save"></fr-loading-button>
                </div>
                <div class="mt-3">
                    <a id="ged-bactosignin"
                        :class="['back', { 'ged-back-link': gedManagerId }]" @click="backUrl"
                        :href="gotoLink">{{ $t('pages.selfservice.passwordReset.returnToSignInAnchorText') }}</a>
                </div>
            </b-form>
        </ValidationObserver>
    </div>
    <div v-else>
        <span show v-if="selfServiceDetails.error === 'Unable to find account'">
            <b>{{$t('pages.selfservice.passwordReset.unablReset')}}</b>
        </span>
        <b-alert variant="danger" v-else-if="!faethmId && !bobClientId" show>
            <b>{{$t('pages.selfservice.passwordReset.unableReset')}}</b>
            <p>{{ selfServiceDetails.error }}</p>
        </b-alert>
        <span variant="danger" v-else-if="faethmId || bobClientId">
            <h1 class="faethm-success-title">{{$t('pages.selfservice.passwordReset.unableReset')}}</h1>
            <p>{{ selfServiceDetails.error }}</p>
        </span>
        <div class="mt-2">
            <div class="mt-2" v-if="this.urlIsToken === false">
                <div class="mt-2" v-if="this.$route.query.otp === 'true'">
                    <a href="#/passwordreset?otp=true" id="lnkPasswordReset">{{$t("pages.selfservice.passwordReset.tryAgain")}}</a>
                </div>
                <div class="mt-2">
                    <a href="#" v-if="isExpiredLink" :class="[{'faethm-tryAgain':(faethmId || bobClientId) }]" @click="navigateToPasswordReset" id="lnkPasswordReset">{{ $t("pages.selfservice.passwordReset.tryAgain") }}</a>
                    <a href="#" v-else @click="reloadPage" id="lnkPasswordReset">{{ $t("pages.selfservice.passwordReset.tryAgain") }}</a>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { has, find, map } from 'lodash';
import LoadingButton from '@/components/utils/LoadingButton';
import InputValidations from '@/components/utils/mixins/InputValidationsMixin';
import { getClientById } from '../../../lib/getClientById';

/**
* @description Selfservice stage for password reset, handles the final result of password reset, either displaying an error or that the reset has been complete
*
**/
export default {
    name: 'Reset-Stage',
    props: {
        selfServiceDetails: { required: true },
        showconf: String,
        showconf1: Boolean,
        show: String,
        urlIsToken: Boolean
    },
    components: {
        'fr-loading-button': LoadingButton
    },
    mixins: [
        InputValidations
    ],
    data () {
        const clientId = this.getQueryStringValue('client_id') || getClientById();
        const spEntityID = this.getQueryStringValue('spEntityID') || getClientById();
        const id = clientId || spEntityID;
        return {
            password: '',
            userPassword: '',
            inputType: 'password',
            inputConfType: 'password',
            defaultPolicyFailures: null,
            loading: false,
            setPasswordKey: this.getQueryStringValue('setPassword'),
            prismClientID: clientId,
            faethmId: id?.includes('faethm'),
            bobClientId: id?.includes('BOB_Client'),
            gedManagerId: id?.includes('ged-client'),
            gedStudentId: id?.includes('ged-student-client'),
            isAccountLinking: this.getQueryStringValue('isLinkingAccounts') === 'true'
        };
    },
    computed: {
        isExpiredLink () {
            const expiredLinkMessages = [
                'Snapshot token is invalid',
                'Token expired',
                'Invalid token'
            ];
            const normalizeMessage = (message) => (message || '').trim().toLowerCase();
            const message = this.selfServiceDetails.message;

            return expiredLinkMessages.some(
                (expiredMessage) => normalizeMessage(expiredMessage) === normalizeMessage(message)
            );
        },
        translatedPasswordField () {
            return this.$t('pages.selfservice.registration.inputValidationMsg.password');
        },
        translatedConfirmPasswordField () {
            return this.$t('pages.selfservice.registration.userDetails.confirmpassword');
        },
        gotoLink () {
            const url = window.location.href;
            const defaultPath = window.location.origin + '/auth/XUI/?realm=/pearson&service=AuthN#login/';
            console.warn('Current URL:', url);
            console.warn('Route query parameters:', this.$route.query);
            console.warn('Default path for redirection:', defaultPath);
            let goto = '';
            if (this.$route.query.goto) {
                goto = decodeURIComponent(this.$route.query.goto);
            } else {
                const gotoMatch = url.match(/goto=([^&#]*)/);
                console.warn('Goto Match result:', gotoMatch);
                if (gotoMatch && gotoMatch[1]) {
                    goto = decodeURIComponent(gotoMatch[1]);
                }
            }
            console.warn('gotoLink in computed properties', goto);
            // Validate and return only relative path to prevent open redirect
            try {
                const parsed = new URL(goto, window.location.origin);
                console.warn('Parsed goto URL:', parsed);
                if (parsed.origin !== window.location.origin) {
                    console.warn('Origin mismatch, redirecting to default path');
                    return defaultPath;
                }
                const relativePath = parsed.pathname + parsed.search + parsed.hash;
                console.warn('Relative path extracted from goto URL:', relativePath);
                if (relativePath.startsWith('/') && !relativePath.startsWith('//')) {
                    console.warn('Returning relative path:', relativePath);
                    return relativePath;
                }
                return defaultPath;
            } catch (e) {
                console.warn('Error parsing goto URL, redirecting to default path', e);
                return defaultPath;
            }
        }
    },
    mounted () {
        if (this.isAccountLinking) {
            const card = document.querySelector('.card.border-xs-0.border-sm.d-flex.fr-stretch-card');
            if (card) {
                card.classList.add('cardStyle');
            }
            const waitForButton = setInterval(() => {
                const button = document.querySelector('.ies-btn.primary.cta-button');
                if (button) {
                    button.classList.add('elementStyle');
                    clearInterval(waitForButton);
                }
                const formControls = document.querySelectorAll('button.form-control.custom-text');
                if (formControls.length > 0) {
                    formControls.forEach(btn => {
                        btn.style.border = 'none';
                        btn.style.display = 'contents';
                    });
                    clearInterval(waitForButton);
                }
                const errorFormControls = document.querySelectorAll('button.form-control.custom-text.error');
                if (errorFormControls.length > 0) {
                    errorFormControls.forEach(btn => {
                        btn.style.border = 'none';
                        btn.style.display = 'contents';
                    });
                    clearInterval(waitForButton);
                }
                const inputGroup = document.querySelectorAll('.input-group-append');
                if (inputGroup) {
                    inputGroup.forEach(group => {
                        Object.assign(group.style, { position: 'absolute', 'margin-left': '21rem' });
                    });
                    clearInterval(waitForButton);
                }
                const input = document.querySelectorAll('.fa-eye.fa');
                if (input) {
                    input.forEach(icon => {
                        Object.assign(icon.style, { padding: '15px' });
                    });
                    clearInterval(waitForButton);
                }
                const passwordField = document.querySelectorAll('input.form-control.custom-text');
                if (passwordField.length > 0) {
                    passwordField.forEach(input => {
                        input.style.width = '388px';
                        input.style.height = '48px';
                    });
                    clearInterval(waitForButton);
                }
            }, 500);
            const cardBody = document.querySelector('.card-body');
            if (cardBody) {
                Object.assign(cardBody.style, { display: 'flex', 'justify-content': 'center', 'padding-top': '10px' });
            }
            const title = document.getElementById('forgot-pwd');
            if (title) {
                title.className = '';
                title.classList.add('titleHeader');
            }
            const back = document.getElementById('ged-bactosignin');
            if (back) {
                back.className = '';
                back.classList.add('backLinkStyle');
            }
            const button = document.querySelector('.ies-btn.primary.cta-button');
            if (button) {
                button.classList.add('custom-submit-button');
            }
        }
        const forgotPasswordElement = document.getElementById('forgot-pwd');
        if (forgotPasswordElement) {
            if (this.isAccountLinking) {
                forgotPasswordElement.textContent = this.$t('pages.selfservice.passwordReset.createPearsonPw');
            } else if (this.faethmId || this.bobClientId) {
                forgotPasswordElement.style.display = 'none';
            }
        }
        var branding = this.selfServiceDetails.requirements?.branding;
        if (branding && branding === 'PEARSONCOLLEGELONDON') {
            document.getElementById('logo').src = require('@/assets/images/pcl.png');
            document.title = 'Pearson - Pearsoncollegelondon';
        }
    },
    methods: {
        forceReauthAndRedirect (url) {
            let redirectUrl = this.gotoLink || url;

            if (!redirectUrl) {
                redirectUrl = window.location.origin + '/auth/XUI/?realm=/pearson&service=AuthN&arg=newsession#login/';
            } else {
                const hashIndex = redirectUrl.indexOf('#');
                if (hashIndex !== -1) {
                    const beforeHash = redirectUrl.substring(0, hashIndex);
                    const hash = redirectUrl.substring(hashIndex);
                    const separator = beforeHash.includes('?') ? '&' : '?';
                    redirectUrl = beforeHash + separator + 'arg=newsession' + hash;
                } else {
                    const separator = redirectUrl.includes('?') ? '&' : '?';
                    redirectUrl = redirectUrl + separator + 'arg=newsession';
                }
            }

            return redirectUrl;
        },
        safeRedirect (url) {
            console.warn('Attempting to redirect to URL:', url);
            const defaultPath = window.location.origin + '/auth/XUI/?realm=/pearson&service=AuthN#login/';
            console.warn('Default path for redirection:', defaultPath);
            if (!url) {
                window.location.assign(defaultPath);
                return;
            }
            try {
                const parsed = new URL(url, window.location.origin);
                console.warn('Parsed URL for redirection:', parsed);
                if (parsed.origin !== window.location.origin) {
                    console.warn('Origin mismatch, redirecting to default path1');
                    window.location.assign(defaultPath);
                    return;
                }
                // Use only relative path - a path starting with '/' cannot redirect to an external origin
                const relativePath = parsed.pathname + parsed.search + parsed.hash;
                console.warn('Relative path for redirection:', relativePath);
                if (relativePath.startsWith('/') && !relativePath.startsWith('//')) {
                    console.warn('Redirecting to relative path:', relativePath);
                    window.location.assign(relativePath);
                } else {
                    console.warn('Invalid relative path, redirecting to default path');
                    window.location.assign(defaultPath);
                }
            } catch (e) {
                console.warn('Error parsing goto URL, redirecting to default path1', e);
                window.location.assign(defaultPath);
            }
        },
        backUrl (event) {
            let goToUrl = this.$route.query.goto;
            const url = window.location.href;
            const hasGoto = url.includes('goto=');
            console.log('gotoUrl in resetStage file', goToUrl);
            if (!goToUrl) {
                event.preventDefault();
                if (hasGoto) {
                    const gotoMatch = url.match(/goto=([^&#]*)/);
                    console.log('Goto Match result:', gotoMatch);
                    if (gotoMatch && gotoMatch[1]) {
                        let decodedGoto = decodeURIComponent(gotoMatch[1]);
                        this.safeRedirect(decodedGoto);
                    }
                } else {
                    console.log('No goto parameter found, navigating to default login page.', goToUrl);
                    window.location.assign(window.location.origin + '/auth/XUI/?realm=/pearson&service=AuthN#login/');
                }
            } else {
                this.safeRedirect(goToUrl);
            }
        },

        navigateToPasswordReset (event) {
            event.preventDefault();

            // Get the hash part after '#/'
            const hash = window.location.hash; // e.g. "#/passwordreset/&token=...&code=...&locale=..."
            let query = {};

            // Remove token and code from the query parameters
            const match = hash.match(/passwordreset\/[&?](.*)/);
            if (match && match[1]) {
                const params = new URLSearchParams(match[1]);
                for (const [key, value] of params.entries()) {
                    if (key !== 'token' && key !== 'code') {
                        query[key] = value;
                    }
                }
            }

            // Route to /passwordreset with the preserved params
            this.$router.push({ path: '/passwordreset', query });
        },
        reloadPage (event) {
            event.preventDefault();
            window.location.reload();
        },
        confirmValidationRules () {
            return `required|confirmed:${this.translatedPasswordField}`;
        },
        // Add additional frontend checks for field validation here
        calculateValidation () {
            const passwordPolicy = this.selfServiceDetails?.requirements?.passwordPolicy || '';
            this.customValidations();
            let validators = [];
            validators.push('required');

            if (['hklongman', 'hk_longman'].includes(passwordPolicy.toLowerCase())) {
                validators.push('minChars');
            } else {
                validators.push('max:120');
                validators.push('pwdSpecialChar');
                validators.push('pwdComplexPassword');
                validators.push('pwdIsNotInBannedList');
                if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.passwordPolicy) {
                    this.selfServiceDetails.requirements.passwordPolicy.toLowerCase() === 'pobl' ? validators.push('pwdIsUniqueforpobl') : validators.push('pwdIsUniqueComplexPassword');
                }
            }

            return validators.join('|');
        },
        getData () {
            return {
                password: this.password,
                userPassword: this.userPassword
            };
        },
        save () {
            this.isValid().then((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$emit('advanceStage', this.getData());
                }
            });
        },
        revealText: function () {
            if (this.inputType === 'password') {
                this.inputType = 'text';
                this.show = true;
            } else {
                this.inputType = 'password';
                this.show = false;
            }
        },

        revealconfirmText: function () {
            if (this.inputConfType === 'password') {
                this.inputConfType = 'text';
                this.showconf = true;
            } else {
                this.inputConfType = 'password';
                this.showconf = false;
            }
        },
        isValid () {
            /* istanbul ignore next */
            return this.$refs.observer.validate();
        },
        getQueryStringValue (name) {
            let url = decodeURIComponent(window.location.href);
            name = name.replace(/[[]/, '\\["').replace(/[\]]/, '\\]');
            let regexS = '[\\?&]' + name + '=([^&#]*)';
            let regex = new RegExp(regexS);
            let results = regex.exec(url);
            return results == null ? null : results[1];
        }
    },
    watch: {
        selfServiceDetails: {
            handler (val) {
                /*
                    If there is a change to selfServiceDetails it's probably because of a
                    policy failure on password that could not be handled on the fly with
                    "?_action=validateObject". Look for those failures here and send them to the
                    PolicyPasswordInput via it's defaultPolicyFailures property.
                */
                if (has(val, 'requirements.error.detail.failedPolicyRequirements')) {
                    let failedPolicy = find(val.requirements.error.detail.failedPolicyRequirements, { property: 'password' });

                    if (failedPolicy && failedPolicy.policyRequirements) {
                        this.defaultPolicyFailures = map(failedPolicy.policyRequirements, 'policyRequirement');
                    }
                }
                if (has(val, 'requirements.error')) {
                    if (typeof val.requirements.error === 'string') {
                        this.selfServiceDetails.validationError = val.requirements.error;
                    }
                    this.loading = false;
                }
                if (this.isAccountLinking && val.tag === 'end') {
                    const forgotPasswordElement = document.getElementById('forgot-pwd');
                    if (forgotPasswordElement) {
                        forgotPasswordElement.textContent = 'Password created';
                    }
                }
            },
            deep: true
        }
    }
};
</script>
<style scoped lang="scss">
@import '../../../scss/pearson-common.css';
</style>
